import Vue from 'vue';
import Vuex from 'vuex';
// import axios from "axios";
import ApiCaller from '../utils/apicaller';
import constant from '../utils/constant';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    userFile: {},
    searchFile: {},
    selectedFolder: '',
    selectedFolderPath: '',
    fileData: [],
    folderData: [],
    routeFolderId: '',
    CurrentFolderId: '',
    SelectedImagesList: [],
    MoveFilebtn: false,
    MoveFolderSlectedId: '',
    SearchValue: false,
    nameNavigation: [{ name: 'Dashboard', value: '/' }],
    folderListDataLength: 0,
    fileListDataLength: 0
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo;
    },
    getFolderId(state) {
      return state.selectedFolder;
    },
    getFolderPath(state) {
      return state.selectedFolderPath;
    },
    getUserFile(state) {
      console.log('=state.userFile=', state.userFile);
      return state.userFile;
    },
    getUserFileData(state) {
      return state.fileData;
    },
    getUserFolderData(state) {
      return state.folderData;
    },
    getSearch(state) {
      return state.searchFile;
    },
    getFileListDataLength(state){
      return state.fileListDataLength
    },
    getFolderListDataLength(state){
      return state.folderListDataLength
    }
  },
  mutations: {
    // setMovedFileList(state)
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setUserFile(state, payload) {
      state.userFile = payload;
      // state.fileData = payload.Data
      // state.folderData = payload.folder
    },
    setSearch(state, payload) {
      state.searchFile = payload;
    },
    setSelectedFolder(state, payload) {
      state.selectedFolder = payload;
    },
    setSelectedFolderPath(state, payload) {
      state.selectedFolderPath = payload;
    },
    setUserFileData(state, payload) {
      console.log('setUserFileData=payload=', payload)
      state.fileData = payload
      console.log('==', state.fileData)
    },
    setUserFolderData(state, payload) {
      console.log('setUserFolderData=payload=', payload)
      state.folderData = payload
    },
    setRouteFolderId(state, payload) {
      state.routeFolderId = payload;
    },
    setCurrentFolderId(state, payload) {
      state.CurrentFolderId = payload;
    },
    setMoveFolderSlectedId(state, payload){
      state.MoveFolderSlectedId = payload
    },
    setSelectedImagesList(state, payload) {
      state.SelectedImagesList = payload;
    },
    setMoveFilebtn(state, payload) {
      console.log('=payload=', payload);
      state.MoveFilebtn = payload;
    },
    setSearchValue(state, payload){
      state.SearchValue = payload
    },
    FolderListDataLength(state, payload){
      state.folderListDataLength = payload
    },
    FileListDataLength(state, payload){
      state.fileListDataLength = payload
    },
    NameNavigationRoute(state, payload) {
      console.log('---', payload);
      if (payload) {
        if (payload === 'remove') {
          state.nameNavigation.pop();
          state.nameNavigation = [{ name: 'Dashboard', value: '/' }];
        } else {
          state.nameNavigation.push(payload);
        }
      }
    },
  },
  actions: {
    async userFile({ commit }, payload) {
      return ApiCaller(
        constant.BASE_API_URL,
        'file/user_file',
        'get',
        null,
        payload.headers
      )
      // .then((response) => {
      //   commit('setUserFile', response);
      //   commit('setUserFolderData', response.folder);
      //   commit('setUserFileData', response.Data);
      // });
    },
    async uploadFile({ commit }, payload) {
      console.log('commit userfile', commit);
      console.log('options:up ', payload.headers);
      console.log('options:upload h ', payload.body);
      // console.log("payload user file: ",payload);
      console.log('==============================>>>>>>>>', payload.body);
      return ApiCaller(
        constant.FILE_UPLOAD_URL,
        '/upload_file/',
        'post',
        payload.body,
        payload.headers
      );
    },
    createFolder({ type }, { payload }) {
      console.log('commit', type);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/create_folder',
        'post',
        payload
      );
    },
    renameFolder({ type }, { payload }) {
      console.log('commit', type);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/rename_folder',
        'post',
        payload
      );
    },
    downloadFile({ type }, { payload }) {
      console.log('commit', type);
      console.log('commit', payload);
      console.log('download', 'file/download' + `/${payload.file_id}`);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/download' + `/${payload.file_id}`,
        'get'
      );
    },
    getUserDataPayboard({type}, {payload}){
      return ApiCaller(
        constant.PAYBOARD_URL,
        'getUserData',
        'post',
         {}
      );
    },
    moveFolder({ type }, { payload }) {
      console.log('commit', type);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/move_to_folder',
        'post',
        payload
      );
    },
    moveFile({ type }, { payload }) {
      console.log('commit', type);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/move_to_file',
        'post',
        payload
      );
    },
    deleteFolder({ type }, { payload }) {
      console.log('commit', type);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/delete_folder',
        'post',
        payload
      );
    },
    deleteFile({ type }, { payload }) {
      console.log('commit userfile', type);
      console.log('download', 'file/download' + `/${payload.file_id}`);
      return ApiCaller(
        constant.BASE_API_URL,
        'file/delete_file' + `/${payload.file_id}`,
        'delete'
      );
    },
    fileShare({ commit }, { type, payload }) {
      return ApiCaller(constant.BASE_API_URL, `file/share/${payload}`, 'get');
    },
    async search({ commit }, { payload }) {
      return ApiCaller(constant.BASE_API_URL, 'auth/search', 'post', payload);
    }, 
    async getUserProfile({ commit }) {
      return ApiCaller(constant.BASE_API_URL, 'auth/profile', 'get').then(
        (response) => {
          commit('setUserInfo', response.data);
        }
      );
    },
  },
  modules: {},
});
